import { PersonTableList } from 'features/personTableList';
import { Margin } from './styles';
import { PersonModalCard } from 'widgets/personModalCard';
import { ModalProvider } from 'shared/ui/modal';
import { selectPerson, usePerson } from 'entities/person';
import { useAppSelector } from 'shared/lib/store';
import { useModal } from 'shared/lib/modal';

export const PersonList = () => {
	const { setPerson } = usePerson();
	const person = useAppSelector(selectPerson);
	const { openModal } = useModal();
	const booking = async () => {
		if (person) {
			await setPerson(person);
			openModal();
		}
	};
	return (
		<Margin>
			<ModalProvider>
				<PersonTableList />
				<PersonModalCard onBooking={booking} />
			</ModalProvider>
		</Margin>
	);
};
